import { useCallback, useContext } from 'react';

import { SignalRContext } from './ContextProvider';

export const useSignalR = () => {
    const context = useContext(SignalRContext);

    if (!context) {
        throw new Error('useSignalR must be used within a SignalRProvider');
    }

    const { connection, connected, startConnection, stopConnection } = context;

    const on = (
        methodName: string,
        newMethod: (...args: Array<any>) => void,
    ) => {
        if (!connection) return;
        connection.on(methodName, newMethod);
    };

    const off = (methodName: string) => {
        if (!connection) return;
        connection.off(methodName);
    };

    const invoke = useCallback(
        async <T = void>(methodName: string, ...args: Array<any>) => {
            if (!connection) return;
            try {
                const result = await connection.invoke<T>(methodName, ...args);
                return result;
            } catch (error) {
                console.error(`Error invoking ${methodName}:`, error);
            }

            return Promise.reject(new Error('Connection not established'));
        },
        [connection],
    );

    return {
        connection: connection,
        connected,
        startConnection,
        stopConnection,
        on,
        off,
        invoke,
    };
};
